import { render, staticRenderFns } from "./Pa2.vue?vue&type=template&id=4c8de6b8&scoped=true"
import script from "./Pa2.vue?vue&type=script&lang=js"
export * from "./Pa2.vue?vue&type=script&lang=js"
import style0 from "./Pa2.vue?vue&type=style&index=0&id=4c8de6b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8de6b8",
  null
  
)

export default component.exports